'use client';

import React from 'react';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import Section from '@/components/Section/Section';
import { ArticlesList } from '@/features/ArticlesList/ArticlesList';
import { Banner } from '@/features/Banner/Banner';
import Blog from '@/features/Blog/Blog';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { FAQ } from '@/features/FAQ/FAQ';
import { Intro } from '@/features/Intro/Intro';
import { ListItems } from '@/features/ListItems/ListItems';
import { OurReviews } from '@/features/OurReviews/OurReviews';
import { Testimonals } from '@/features/Testimonals/Testimonals';
import {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  industries,
  intro,
  reviews,
  testimonals,
} from '@/lib/industries/window-cleaning';

const WindowCleaning = () => {
  return (
    <>
      <Intro withVideo={false} imageSrc={intro.imageSrc.src} item={intro} />

      <Section>
        <Container>
          <FullArticle item={fullArticle1} />
        </Container>
      </Section>

      <Section>
        <Banner
          title={`Experience the convenience of our flexible, customizable window washing software on any device.`}
          subTitle="Elevate Your Window Cleaning Business Today"
          thirtTitle=""
          listItems={[]}
        />
      </Section>

      <Container>
        <Section title={articles.title}>
          <ArticlesList {...articles} />
        </Section>
      </Container>

      <Section>
        <Container>
          <OurReviews item={reviews} />
        </Container>
      </Section>

      <Section>
        <Container>
          <FullArticle item={fullArticle2} />
        </Container>
      </Section>

      <Section>
        <Banner
          title={`Take The Next Step With And Learn More About Our Solutions`}
          subTitle="Ready to Optimize Your Window Cleaning Business?"
          listItems={[
            { title: 'Free version' },
            { title: 'Onboarding and support' },
            { title: 'Data migration' },
            { title: '24/7 customer service' },
          ]}
        />
      </Section>

      <Section>
        <Container>
          <Testimonals title="Our Testimonials" items={testimonals} />
        </Container>
      </Section>

      <Container>
        <Section title="FAQ">
          <FAQ items={faq} />
        </Section>
      </Container>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <Blog />
          </Section>
        </Container>
      </BlogLayout>

      <Container>
        <Section title={industries.title} description={industries.description}>
          <ListItems {...industries} />
        </Section>
      </Container>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default WindowCleaning;
